import { createAsyncThunk } from '@reduxjs/toolkit'

import { getPageStateSafe, RootState } from '@app/model/store/client'
import SelectionItemReducer, { setLoading, setPaginationPage, setSelectionList } from '@pages/SelectionItem/model/slice'
import { addTemporaryNotice } from '@widgets/Common/Notices/model/actions'
import { API } from '@shared/api'

const fallbackSelectionItemState = SelectionItemReducer(undefined, { type: 'init' })

type SelectionItemThunkConfig = { state: RootState }

export const loadMorePage = createAsyncThunk<void, void, SelectionItemThunkConfig>(
  'selectionItem/loadMorePage',
  async (_action, { dispatch, getState }) => {
    const selectionItemState = getPageStateSafe(getState(), 'selection_item', fallbackSelectionItemState)
    const state = selectionItemState.selection

    const { items_addition, items_full } = state.loading
    const nextPage = state.pagination?.page?.next?.number
    if (items_addition || items_full || !nextPage) return
    if (!state.paramsRequest?.params) return

    dispatch(setLoading({ ...state.loading, items_addition: true }))

    const params = {
      ...state.paramsRequest,
      params: {
        ...state.paramsRequest.params,
        page: nextPage,
      },
    }

    API.selection_restaurants(params)
      .then((response) => {
        dispatch(setSelectionList([...state.restaurants, ...response.results]))
        dispatch(setPaginationPage(response.pagination))
      })
      .catch((error) => {
        console.error(`'Ошибка загрузки списка ресторанов' - ${error}`)

        dispatch(addTemporaryNotice({ markup: 'Ошибка загрузки списка ресторанов' }))
      })
      .finally(() => {
        dispatch(setLoading({ ...state.loading, items_addition: false }))
      })
  },
)

export const loadPage = createAsyncThunk<void, number, SelectionItemThunkConfig>(
  'selectionItem/loadPage',
  async (pageNumber, { dispatch, getState }) => {
    const selectionItemState = getPageStateSafe(getState(), 'selection_item', fallbackSelectionItemState)
    const state = selectionItemState.selection

    const { items_addition, items_full } = state.loading
    if (items_addition || items_full) return
    if (!state.paramsRequest?.params) return

    dispatch(setLoading({ ...state.loading, items_full: true }))

    const params = {
      ...state.paramsRequest,
      params: {
        ...state.paramsRequest.params,
        page: pageNumber,
      },
    }

    API.selection_restaurants(params)
      .then((response) => {
        dispatch(setSelectionList(response.results))
        dispatch(setPaginationPage(response.pagination))
      })
      .catch((error) => {
        console.error(`'Ошибка загрузки списка ресторанов' - ${error}`)
        dispatch(addTemporaryNotice({ markup: 'Ошибка загрузки списка ресторанов' }))
      })
      .finally(() => {
        dispatch(setLoading({ ...state.loading, items_full: false }))
      })
  },
)
